import React from 'react';
import { FileText, Download, TrendingUp, DollarSign } from 'lucide-react';
import { Header } from '../components/Header.js';
import { EduCard } from '../components/EduCard.js';
import { EduButton } from '../components/EduButton.js';

export const Reports: React.FC = () => {
  return (
    <div>
      <Header
        title="Relatórios Executivos"
        subtitle="Consolidação contábil, evolução de assinaturas e métricas de produção de vídeo"
        action={
          <EduButton
            variant="secondary"
            size="sm"
            onClick={() => alert('Download do relatório mensal gerado em PDF.')}
            icon={<Download size={14} />}
          >
            Exportar Relatório Mensal
          </EduButton>
        }
      />

      <div className="p-8 max-w-7xl mx-auto space-y-6">
        <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
          <EduCard
            title={
              <div className="flex items-center gap-2">
                <DollarSign className="text-brand-primary" size={18} />
                <span>Demonstrativo Financeiro de Receita Recorrente</span>
              </div>
            }
          >
            <div className="space-y-4">
              <div className="flex justify-between items-center pb-2 border-b border-bdr text-xs">
                <span className="text-txt-secondary">Receita Mensal Recorrente (MRR):</span>
                <strong className="text-base font-bold text-txt-primary">R$ 19.900,00</strong>
              </div>
              <div className="flex justify-between items-center pb-2 border-b border-bdr text-xs">
                <span className="text-txt-secondary">Taxa de Renovação Contratual:</span>
                <strong className="text-base font-bold text-status-success">98.5%</strong>
              </div>
              <div className="flex justify-between items-center text-xs">
                <span className="text-txt-secondary">Projeção ARR Anualizada:</span>
                <strong className="text-base font-bold text-brand-primary">R$ 238.800,00</strong>
              </div>
            </div>
          </EduCard>

          <EduCard
            title={
              <div className="flex items-center gap-2">
                <TrendingUp className="text-status-info" size={18} />
                <span>Eficiência do Motor de Vídeo</span>
              </div>
            }
          >
            <div className="space-y-4">
              <div className="flex justify-between items-center pb-2 border-b border-bdr text-xs">
                <span className="text-txt-secondary">Taxa de Conclusão sem Falhas:</span>
                <strong className="text-base font-bold text-status-success">99.2%</strong>
              </div>
              <div className="flex justify-between items-center pb-2 border-b border-bdr text-xs">
                <span className="text-txt-secondary">Custo Médio de Hardware / Vídeo:</span>
                <strong className="text-base font-bold text-txt-primary">R$ 0,12</strong>
              </div>
              <div className="flex justify-between items-center text-xs">
                <span className="text-txt-secondary">Minutos Produzidos no Mês:</span>
                <strong className="text-base font-bold text-txt-primary">1.420 min</strong>
              </div>
            </div>
          </EduCard>
        </div>
      </div>
    </div>
  );
};
